<template>
  <div class="apply-record">
    <div class="item" v-for="item in this.records" :key="item.id">
      <div class="status">
        <span class="name" :class="[ 'status' + item.statusCss ]">{{ item.statusText }}</span>
        <span class="date">{{ item.createdDate && item.createdDate.format("yyyy-MM-dd hh:mm:ss") }}</span>
      </div>
      <div class="con">
        <div class="img">
          <img :src="item.imgs.length>0 && item.imgs[0]" @click="preview(item.imgs, 0)" />
        </div>
        <div class="words">
          <h3>{{ item.desc }}</h3>
          <div class="remark">
            共{{ item.imgs.length }}张图片
          </div>
        </div>
      </div>
      <div class="option">
        <y-button v-if="(item.statusMask & 4) == 4" class="btn" @click="apply(item)">重新提交</y-button>
        <y-button v-if="(item.statusMask & 2) == 2" class="btn" @click="cancel(item)">取消申请</y-button>
        <y-button v-if="(item.statusMask & 1) == 1" class="btn primary" @click="goto('/apply/record/'+item.id)">查看详情</y-button>
      </div>
    </div>
  </div>
</template>


<script>
import { Dialog } from 'vant';
import { ImagePreview } from "vant";
import { login } from "../../scripts/auth";
import { httpOpen } from "../../scripts/network";

export default {
  name: "ApplyRecord",
  data() {
    return {
      records: [],
    };
  },
  created() {
    this.loadRecords();
  },
  methods: {
    async loadRecords() {
      console.log('加载申请记录中！');
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/ServiceApplyList", {
          type: "post",
          body: { // 分页参数为空,表示不分页
          },
        });
        if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        } else if (!ret.Status) {
          this.$toast(ret.Message || "加载失败，请稍后重试");
        } else {
          this.records =
            ret.Data.map((r) => {
              let record = {
                id: r.SysNo,
                cardSysNo: r.WfcOrderSysNo,
                status: r.AuditStatus,
                imgs: r.AppendDixList.map((a) => a.AppendixContent) || [],
                desc: r.CustomerMessage,
                createdDate: r.CreatedDate && new Date(r.CreatedDate + "+08:00"),
              };
              this.statusMapper(record)
              return record;
            }) || [];
        }
        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    statusMapper(record) {
      // 未审核 = 10,审核通过 = 20,审核不通过 = 30, 已取消 = 40
      switch (parseInt(record.status)) {
        case 10:
          record.statusText = "审核中";
          record.statusMask = 1 | 2;
          record.statusCss = 1;
          break;
        case 20:
          record.statusText = "审核通过";
          record.statusMask = 1;
          record.statusCss = 3;
          break;
        case 30:
          record.statusText = "审核未通过";
          record.statusMask = 1 | 4;
          record.statusCss = 2;
          break;
        case 40:
          record.statusText = "已取消";
          record.statusMask = 1;
          record.statusCss = 1;
        break;
        default:
          record.statusText = record.status;
          record.statusMask = 0;
          record.statusCss = 1;
          break;
      }
    },
    apply(record) {
      this.$router.push({
        name: "ServiceForm",
        params: {
          id: record.cardSysNo,
        },
        query: {
          applyId : record.id
        }
      });
    },
    async doCancel(record){
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/ServiceApplyCancel", {
          type: "post",
          body: {
            SysNo: record.id,
          },
        });
        if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        } else if (!ret.Status) {
          this.$toast(ret.Message || "取消失败");
        } else {
          this.$toast("取消成功");
          
          record.status = 40;
          this.statusMapper(record); // 已取消
        }
        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    async cancel(record) {
      Dialog.confirm({
        message: '当前申请正在审核中 是否确认取消？'
      }).then(()=>{
        this.doCancel(record);
      }).catch(()=> {
      });
    },
    preview(imgs,index){
      ImagePreview({
        images: imgs, 
        showIndex: true,
        loop: true,
        startPosition: index
      });
    },
  },
};
</script>

<style lang="less" scoped>
  .apply-record{
    padding: 12px 12px 60px 12px;
    min-height: 100vh;
    background-color: #f4f4f4;
    box-sizing: border-box;
    .item{
      background-color: #fff;
      border-radius: 6px;
      padding: 14px 10px;
      &:not(:first-child){
        margin-top: 10px;
      }
      .status{
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        align-items: center;
        .name{
          font-size: 14px;
          border-radius: 10px;
          display: inline-block;
          padding: 3px 8px;
          &.status1{
            color: #785c27;
            background-color: #FFF5F5;
          }
          &.status2{
            color: #BD5B5B;
            background-color: #EAFFF7;
          }
          &.status3{
            color: #49A36D;
            background-color: #EBEBEB;
          }
        }
        .date{
          font-size: 14px;
          color: rgba(0,0,0,0.85);
        }
      }
      .con{
        display: flex;
        border-bottom: 1px solid #f0f0f0;
        padding-bottom: 10px;
        margin-bottom: 10px;
        .img{
          >img{
            width: 75px;
            height: 75px;
            object-fit: cover;
          }
        }
        .words{
          flex: 1 1;
          margin-left: 17px;
          h3{
            font-size: 16px;
            color: rgba(0,0,0,0.85);
            padding: 0;
            margin: 0;
          }
          .remark{
            margin-top: 4px;
            font-size: 12px;
            color: rgba(0,0,0,0.85);
          }
        }
      }
      .option{
        display: flex;
        justify-content: flex-end;
        .btn{
          width: 85px;
          margin-left: 5px;
          background: #EBEBEB;
          border: 1px solid #D9D9D9;
          font-size: 12px;
          color: #000;
          height: 32px;
          &.primary{
            color: #FFE0A5;
            background: linear-gradient(118deg, #383838 8%, #2F2F2F 84%);
          }
        }
      }
    }
  }
</style>